{
  "generic": {
    "no": "Ні",
    "yes": "Так",
    "text": "Текст "
  },
  "consent": {
    "defaultLabelText": "Надсилаючи цю форму, ви погоджуєтеся з нашою ",
    "defaultLabelLink": "політикою конфіденційності"
  },
  "text": {
    "defaultHeadlineText": "Це заголовок",
    "defaultText": "Це текстовий блок",
    "floatingDefaultText": "НОВЕ!"
  },
  "button": {
    "submitDefaultText": "Надіслати",
    "instagramDefaultText": "Слідкуйте за нами",
    "defaultText": "Натисніть тут",
    "closing": "ЗАКРИТТЯ..."
  },
  "input": {
    "emailLabel": "Електронна пошта",
    "emailPlaceholder": "Введіть свою електронну пошту",
    "passwordLabel": "Пароль",
    "passwordPlaceholder": "Введіть пароль",
    "nameLabel": "Ім'я",
    "namePlaceholder": "Введіть своє ім'я",
    "firstNameLabel": "Ім'я",
    "firstNamePlaceholder": "Введіть ім'я",
    "lastNameLabel": "Прізвище",
    "lastNamePlaceholder": "Введіть прізвище",
    "phoneLabel": "Телефон",
    "phonePlaceholder": "Введіть номер телефону",
    "textareaLabel": "Повідомлення",
    "textareaPlaceholder": "Введіть своє повідомлення",
    "regularLabel": "Текст",
    "regularPlaceholder": "Введіть текст",
    "defaultLabel": "Мітка",
    "defaultPlaceholder": "Заповнювач",
    "datePlaceholder": "Виберіть дату",
    "stepLabel": "Введіть своє запитання тут"
  },
  "dropdown": {
    "placeholder": "Виберіть опцію",
    "firstItem": "Опція 1",
    "secondItem": "Опція 2",
    "chooseCountry": "Країна"
  },
  "buttonList": {
    "firstItem": "Опція 1",
    "secondItem": "Опція 2",
    "option1": "Вибір 1",
    "option2": "Вибір 2",
    "option3": "Вибір 3",
    "subscriptionItem1": "Розсилка",
    "subscriptionItem2": "Оновлення",
    "chooseSubscriptionTopics": "Виберіть теми підписки",
    "other": "Інше",
    "uncheck-all-label": "Я не хочу отримувати жодного з цих листів"
  },
  "rating": {
    "rateLabel": "Оцініть нас",
    "npsLabel": "Наскільки ймовірно, що ви порекомендуєте нас?",
    "veryUnsatisfied": "Дуже незадоволений",
    "unsatisfied": "Незадоволений",
    "neutral": "Нейтральний",
    "satisfied": "Задоволений",
    "loveIt": "Обожнюю!",
    "minValueLabel": "Низький",
    "maxValueLabel": "Високий",
    "minValueLabelNps": "Малоймовірно",
    "maxValueLabelNps": "Дуже ймовірно"
  },
  "deadline": {
    "days": "Дні",
    "hours": "Години",
    "minutes": "Хвилини",
    "seconds": "Секунди"
  },
  "bulletList": {
    "firstItem": "Перевага 1",
    "secondItem": "Перевага 2"
  },
  "discountCode": {
    "copyMessage": "Скопійовано до буфера обміну!",
    "fallback": "WELCOME10",
    "textDefault": "Ваш код знижки",
    "buttonDefault": "Копіювати"
  },
  "share": {
    "buttonText": "Поділитися"
  },
  "common": {
    "label": "Мітка"
  },
  "wcag": {
    "banner": "Рекламний банер",
    "closeButton": "Закрити",
    "submitButton": "Надіслати форму"
  },
  "spinTheWheel": {
    "prizeWonText": "Вітаємо!",
    "prizeWonButtonText": "Отримайте свій приз",
    "prizeLostText": "Ой, шкода! :-(",
    "prizeLostButtonText": "Натисніть, щоб закрити",
    "spinButtonLabel": "КРУТИТИ"
  },
  "memory": {
    "resultWonText": "Чудова робота! Ваш час був {elapsedTime}",
    "resultWonButtonText": "Отримайте свій приз"
  },
  "stepNavigation": {
    "nextButtonText": "Далі",
    "previousButtonText": "Назад",
    "lastButtonText": "Закрити",
    "submitButtonText": "Надіслати"
  },
  "defaultRealTimeMessage": {
    "validationError": "Будь ласка, перевірте формат надісланих даних.",
    "unknownError": "Під час надсилання виникла непередбачена проблема.",
    "conflictError": "Цей користувач вже існує.",
    "success": "Форму надіслано."
  }
}
